/** Second half of the OPAC catalogue: digital card, patron account pages and the kiosk. */
export const opacMoreEn = {
  // digital card
  'card.libraryCard': 'Library card',
  'card.number': 'Card number',
  'card.validThru': 'Valid until',
  'card.noExpiry': 'No expiry',
  'card.fullscreen': 'Full screen for scanning',
  'card.qrAlt': 'QR code of your library card number',
  'card.qrUnavailable': 'QR code unavailable offline',
  'card.scanHelp': 'Hold this screen under the scanner at the desk or gate. Brightness is kept up while it is open.',
  'card.expiresSoon': 'Your membership expires in {days} days. Ask at the desk to renew.',
  'card.expiredAgo': 'Your membership expired {days} days ago.',
  'card.savedOffline': 'Saved for offline use',
  'card.offlineCopy': 'Offline copy',
  // kiosk
  'kiosk.touchToStart': 'Touch to start',
  'kiosk.cardHelp': 'Hold the barcode on your card under the scanner, or type the card number.',
  'kiosk.cardField': 'Library card number',
  'kiosk.cardPlaceholder': 'Scan or type your card number',
  'kiosk.enterPin': 'Enter your PIN',
  'kiosk.pinPrompt': 'Your PIN',
  'kiosk.pinEntered': '{count} digits entered',
  'kiosk.backspace': 'Delete last digit',
  'kiosk.typePassword': 'Or type your password',
  'kiosk.continue': 'Continue',
  'kiosk.differentCard': 'Use a different card',
  'kiosk.mode': 'What would you like to do?',
  'kiosk.borrow': 'Borrow',
  'kiosk.return': 'Return',
  'kiosk.scanReturn': 'Scan the books you are returning',
  'kiosk.itemField': 'Item barcode',
  'kiosk.itemPlaceholder': 'Scan the barcode on the book',
  'kiosk.dueOn': 'Due {date}',
  'kiosk.returned': 'Returned, thank you',
  'kiosk.fine': 'Late fee {amount} for {days} days',
  'kiosk.askStaff': 'Please see a staff member',
  'kiosk.loansNow': '{count} items on your card',
  'kiosk.thanks': 'Thank you!',
  'kiosk.receipt': 'Receipt',
  'kiosk.borrowed': 'Borrowed',
  'kiosk.returnedHeading': 'Returned',
  'kiosk.notProcessed': 'Not processed',
  'kiosk.nothing': 'No items were processed.',
  'kiosk.finish': 'Finish',
  'kiosk.timedOut': 'Your session ended because there was no activity.',
  'kiosk.disabledHelp': 'Please use the circulation desk. Our staff will be happy to help.',
  'kiosk.unreachable': 'Self checkout is temporarily unavailable',
  // account overview
  'opac.account.welcome': 'Welcome back',
  'opac.account.sections': 'Account sections',
  'opac.account.debarred': 'Your account is restricted',
  'opac.account.expired': 'Your membership has expired',
  'opac.account.expiredHelp': 'It expired on {date}. Ask at the desk to renew before you borrow again.',
  'opac.account.cannotBorrow': 'You cannot borrow right now. Check your fines and restrictions.',
  'opac.account.dueSoon': 'Due soon',
  'opac.account.holdsReady': 'Holds ready / total',
  'opac.account.unread': 'Unread messages',
  'opac.account.openRequests': 'Open requests',
  'opac.account.dueNext': 'Due next',
  'opac.account.noLoans': 'Nothing on loan. Find something to read.',
  'opac.account.noEvents': 'You have not registered for any events',
  'opac.account.noBookings': 'You have no room bookings',
  'opac.dueToday': 'Due today',
  'opac.dueSoon': 'Due soon',
  // loans
  'opac.loans.empty': 'No books on loan',
  'opac.loans.emptyHelp': 'Borrowed books show up here with their due dates.',
  'opac.loans.renewed': 'Loan renewed',
  'opac.loans.renewedTo': 'Renewed. New due date {date}.',
  'opac.loans.cannotRenew': 'This item cannot be renewed.',
  'opac.loans.renewFrom': 'Renewal opens on {date}.',
  'opac.loans.renewalsLeft': '{count} renewals left',
  'opac.loans.daysOverdue': '{count} days overdue',
  'opac.loans.renewAllResult': '{renewed} renewed, {failed} could not be renewed',
  // holds
  'opac.holds.empty': 'No holds yet',
  'opac.holds.emptyHelp': 'Place a hold on any title and we will tell you when it is ready.',
  'opac.holds.showHistory': 'Show past holds',
  'opac.holds.readyTitle': '{count} hold(s) ready for pickup',
  'opac.holds.readyHelp': 'Collect them from the pickup shelf before the deadline shown.',
  'opac.holds.status.PENDING': 'In queue',
  'opac.holds.status.WAITING': 'Ready for pickup',
  'opac.holds.status.IN_TRANSIT': 'On its way',
  'opac.holds.status.IN_PROCESSING': 'Being prepared',
  'opac.holds.status.FILLED': 'Collected',
  'opac.holds.status.CANCELLED': 'Cancelled',
  'opac.holds.status.EXPIRED': 'Expired',
  'opac.holds.suspended': 'Paused',
  'opac.holds.suspendedUntil': 'Paused until {date}',
  'opac.holds.suspend': 'Pause hold',
  'opac.holds.suspendUntil': 'Pause until',
  'opac.holds.suspendHint': 'Leave empty to pause until you resume it.',
  'opac.holds.suspendedToast': 'Hold paused',
  'opac.holds.resume': 'Resume hold',
  'opac.holds.resumedToast': 'Hold resumed',
  'opac.holds.edit': 'Edit hold',
  'opac.holds.updated': 'Hold updated',
  'opac.holds.cancelHold': 'Cancel hold',
  'opac.holds.cancelTitle': 'Cancel this hold?',
  'opac.holds.cancelBody': 'You will lose your place in the queue for {title}.',
  'opac.holds.cancelledToast': 'Hold cancelled',
  'opac.holds.pickupBy': 'Pick up by',
  'opac.holds.pickupByDate': 'Pick up by {date}',
  'opac.holds.placedOn': 'Placed {date}',
  // fines
  'opac.fines.outstanding': 'Outstanding',
  'opac.fines.credits': 'Credit available',
  'opac.fines.balance': 'Balance',
  'opac.fines.toPay': 'Charges to pay',
  'opac.fines.pay': 'Pay {amount}',
  'opac.fines.payAtDesk': 'Pay at the library desk',
  'opac.fines.secureNote': 'Payments are processed securely. You will get a receipt when it completes.',
  'opac.fines.statement': 'Account statement',
  'opac.fines.empty': 'No charges',
  'opac.fines.emptyHelp': 'Fines and fees will appear here.',
  'opac.fines.description': 'Description',
  'opac.fines.amount': 'Amount',
  'opac.fines.voided': 'Voided',
  'opac.fines.paidTitle': 'Payment of {amount} received',
  'opac.fines.paidBody': 'Your account has been updated.',
  'opac.fines.receipt': 'Receipt {number}',
  'opac.fines.sandboxNote': 'Sandbox payment: no real money moved.',
  'opac.fines.dismissed': 'Payment was cancelled before it completed.',
  'opac.fines.providerFailed': 'The payment window could not be opened. Please try again.',
  // history
  'opac.history.privacy': 'Reading history privacy',
  'opac.history.privacyHelp.DEFAULT': 'Your history is kept for the library default period, then removed.',
  'opac.history.privacyHelp.FOREVER': 'Your history is kept until you clear it.',
  'opac.history.privacyHelp.NEVER': 'No history is kept. Returned books are forgotten immediately.',
  'opac.history.policy.DEFAULT': 'Default',
  'opac.history.policy.FOREVER': 'Keep',
  'opac.history.policy.NEVER': 'Never',
  'opac.history.privacySaved': 'Privacy setting saved',
  'opac.history.search': 'Search your history',
  'opac.history.clear': 'Clear history',
  'opac.history.clearTitle': 'Clear your reading history?',
  'opac.history.clearBody': 'This permanently removes every returned loan from your history. Type DELETE to confirm.',
  'opac.history.cleared': 'History cleared',
  'opac.history.returned': 'returned {date}',
  'opac.history.empty': 'No history yet',
  'opac.history.emptyHelp': 'Books you return will be listed here.',
  'opac.history.off': 'History is switched off',
  'opac.history.offHelp': 'Choose Default or Keep above to start recording what you read.',
  // lists
  'opac.list.edit': 'Edit list',
  'opac.list.saved': 'List saved',
  'opac.list.deleted': 'List deleted',
  'opac.list.description': 'Description',
  'opac.list.visibility': 'Who can see it',
  'opac.list.visibility.PRIVATE': 'Only me',
  'opac.list.visibility.SHARED': 'Anyone with the link',
  'opac.list.visibility.PUBLIC': 'Everyone',
  'opac.list.visibilityHelp.PRIVATE': 'Only you can see this list.',
  'opac.list.visibilityHelp.SHARED': 'People with the share link can see it.',
  'opac.list.visibilityHelp.PUBLIC': 'Listed on the public lists page.',
  'opac.list.shareLink': 'Create share link',
  'opac.list.stopSharing': 'Stop sharing',
  'opac.list.deleteTitle': 'Delete this list?',
  'opac.list.deleteBody': '"{name}" and its entries will be removed.',
  'opac.list.emptyList': 'This list is empty',
  'opac.list.emptyListHelp': 'Open any book and choose Add to list.',
  'opac.list.moveUp': 'Move up',
  'opac.list.moveDown': 'Move down',
  'opac.list.none': 'No lists yet',
  'opac.list.noneHelp': 'Keep track of what you want to read, or share a reading list with friends.',
  // suggestions
  'opac.suggest.new': 'Suggest a title',
  'opac.suggest.help': 'Tell us what the library should buy. We review every suggestion.',
  'opac.suggest.titleField': 'Title',
  'opac.suggest.author': 'Author',
  'opac.suggest.publisher': 'Publisher',
  'opac.suggest.reason': 'Why should we buy it?',
  'opac.suggest.send': 'Send suggestion',
  'opac.suggest.sent': 'Suggestion sent. Thank you!',
  'opac.suggest.empty': 'No suggestions yet',
  'opac.suggest.emptyHelp': 'Cannot find a book? Suggest it for purchase.',
  'opac.suggest.withdraw': 'Withdraw',
  'opac.suggest.withdrawTitle': 'Withdraw this suggestion?',
  'opac.suggest.withdrawn': 'Suggestion withdrawn',
  // interlibrary loans
  'opac.ill.new': 'New request',
  'opac.ill.help': 'Ask us to borrow a title that this library does not hold.',
  'opac.ill.article': 'Article or chapter title',
  'opac.ill.articleHint': 'Only if you need a copy of one article rather than the whole book.',
  'opac.ill.neededByField': 'Needed by',
  'opac.ill.send': 'Send request',
  'opac.ill.sent': 'Request sent',
  'opac.ill.empty': 'No interlibrary requests',
  'opac.ill.emptyHelp': 'We can borrow books and articles from other libraries for you.',
  'opac.ill.requested': 'Requested {date}',
  'opac.ill.neededBy': 'Needed by {date}',
  'opac.ill.fee': 'Fee {amount}',
  'opac.ill.cancel': 'Cancel request',
  'opac.ill.cancelTitle': 'Cancel this request?',
  'opac.ill.cancelled': 'Request cancelled',
  // events and bookings
  'opac.event.waitlistPos': 'Waitlist #{position}',
  'opac.rooms.bookings': 'Room bookings',
  'opac.rooms.cancel': 'Cancel booking',
  'opac.rooms.cancelTitle': 'Cancel this booking?',
  'opac.rooms.cancelled': 'Booking cancelled',
  // profile, notifications, preferences
  'opac.me.saved': 'Profile saved',
  'opac.me.member': 'Member since {date}',
  'opac.me.changePhoto': 'Change photo',
  'opac.me.photoSaved': 'Photo updated',
  'opac.me.nameLocked': 'Your name is managed by the library. Ask at the desk to change it.',
  'opac.me.secondaryEmail': 'Second email',
  'opac.me.address2': 'Address line 2',
  'opac.me.language': 'Language',
  'opac.me.changePassword': 'Change password',
  'opac.me.currentPassword': 'Current password',
  'opac.me.newPassword': 'New password',
  'opac.me.passwordChanged': 'Password changed',
  'opac.me.markAllRead': 'Mark all read',
  'opac.me.markRead': 'Mark read',
  'opac.me.allRead': 'All notifications marked as read',
  'opac.me.noNotifications': 'No notifications',
  'opac.me.noNotificationsHelp': 'Holds ready, due dates and library news will appear here.',
  'opac.me.appearance': 'Language and theme',
  'opac.me.theme': 'Theme',
  'opac.me.themeLight': 'Light',
  'opac.me.themeDark': 'Dark',
  'opac.me.themeSystem': 'System',
  'opac.me.messaging': 'How we contact you',
  'opac.me.messagingHelp': 'Choose where each kind of notice is sent.',
  'opac.me.noticeType': 'Notice',
  'opac.me.medium.EMAIL': 'Email',
  'opac.me.medium.SMS': 'SMS',
  'opac.me.medium.PUSH': 'App',
  'opac.me.medium.WHATSAPP': 'WhatsApp',
  'opac.me.digest': 'Combine into one daily message',
  'opac.me.prefsSaved': 'Preferences saved',
} as const;

export const opacMoreHi: Record<keyof typeof opacMoreEn, string> = {
  'card.libraryCard': 'पुस्तकालय कार्ड',
  'card.number': 'कार्ड नंबर',
  'card.validThru': 'मान्य तिथि',
  'card.noExpiry': 'कोई समाप्ति नहीं',
  'card.fullscreen': 'स्कैन के लिए पूर्ण स्क्रीन',
  'card.qrAlt': 'आपके पुस्तकालय कार्ड नंबर का QR कोड',
  'card.qrUnavailable': 'ऑफ़लाइन QR कोड उपलब्ध नहीं',
  'card.scanHelp': 'इस स्क्रीन को डेस्क या गेट के स्कैनर के नीचे रखें। खुले रहने तक चमक बनी रहती है।',
  'card.expiresSoon': 'आपकी सदस्यता {days} दिन में समाप्त हो रही है। नवीनीकरण के लिए डेस्क पर पूछें।',
  'card.expiredAgo': 'आपकी सदस्यता {days} दिन पहले समाप्त हो गई।',
  'card.savedOffline': 'ऑफ़लाइन उपयोग के लिए सहेजा गया',
  'card.offlineCopy': 'ऑफ़लाइन प्रति',
  'kiosk.touchToStart': 'शुरू करने के लिए छुएँ',
  'kiosk.cardHelp': 'अपने कार्ड का बारकोड स्कैनर के नीचे रखें या कार्ड नंबर टाइप करें।',
  'kiosk.cardField': 'पुस्तकालय कार्ड नंबर',
  'kiosk.cardPlaceholder': 'कार्ड नंबर स्कैन करें या टाइप करें',
  'kiosk.enterPin': 'अपना पिन दर्ज करें',
  'kiosk.pinPrompt': 'आपका पिन',
  'kiosk.pinEntered': '{count} अंक दर्ज हुए',
  'kiosk.backspace': 'अंतिम अंक हटाएँ',
  'kiosk.typePassword': 'या अपना पासवर्ड टाइप करें',
  'kiosk.continue': 'आगे बढ़ें',
  'kiosk.differentCard': 'दूसरा कार्ड उपयोग करें',
  'kiosk.mode': 'आप क्या करना चाहेंगे?',
  'kiosk.borrow': 'उधार लें',
  'kiosk.return': 'वापस करें',
  'kiosk.scanReturn': 'वापस की जा रही किताबें स्कैन करें',
  'kiosk.itemField': 'आइटम बारकोड',
  'kiosk.itemPlaceholder': 'किताब पर लगा बारकोड स्कैन करें',
  'kiosk.dueOn': 'देय तिथि {date}',
  'kiosk.returned': 'वापस हुई, धन्यवाद',
  'kiosk.fine': '{days} दिन की देरी का शुल्क {amount}',
  'kiosk.askStaff': 'कृपया स्टाफ से मिलें',
  'kiosk.loansNow': 'आपके कार्ड पर {count} आइटम',
  'kiosk.thanks': 'धन्यवाद!',
  'kiosk.receipt': 'रसीद',
  'kiosk.borrowed': 'उधार ली गईं',
  'kiosk.returnedHeading': 'वापस की गईं',
  'kiosk.notProcessed': 'संसाधित नहीं हुईं',
  'kiosk.nothing': 'कोई आइटम संसाधित नहीं हुआ।',
  'kiosk.finish': 'समाप्त करें',
  'kiosk.timedOut': 'कोई गतिविधि न होने के कारण आपका सत्र समाप्त हो गया।',
  'kiosk.disabledHelp': 'कृपया सर्कुलेशन डेस्क का उपयोग करें। हमारा स्टाफ मदद करेगा।',
  'kiosk.unreachable': 'सेल्फ चेकआउट अस्थायी रूप से अनुपलब्ध है',
  'opac.account.welcome': 'वापसी पर स्वागत है',
  'opac.account.sections': 'खाता अनुभाग',
  'opac.account.debarred': 'आपका खाता प्रतिबंधित है',
  'opac.account.expired': 'आपकी सदस्यता समाप्त हो गई है',
  'opac.account.expiredHelp': 'यह {date} को समाप्त हुई। दोबारा उधार लेने से पहले डेस्क पर नवीनीकरण कराएँ।',
  'opac.account.cannotBorrow': 'अभी आप उधार नहीं ले सकते। अपने शुल्क और प्रतिबंध देखें।',
  'opac.account.dueSoon': 'जल्द देय',
  'opac.account.holdsReady': 'तैयार / कुल होल्ड',
  'opac.account.unread': 'अपठित संदेश',
  'opac.account.openRequests': 'खुले अनुरोध',
  'opac.account.dueNext': 'अगली देय',
  'opac.account.noLoans': 'कुछ उधार नहीं है। पढ़ने के लिए कुछ खोजें।',
  'opac.account.noEvents': 'आपने किसी कार्यक्रम में पंजीकरण नहीं किया है',
  'opac.account.noBookings': 'आपकी कोई कक्ष बुकिंग नहीं है',
  'opac.dueToday': 'आज देय',
  'opac.dueSoon': 'जल्द देय',
  'opac.loans.empty': 'कोई किताब उधार नहीं है',
  'opac.loans.emptyHelp': 'उधार ली गई किताबें देय तिथि के साथ यहाँ दिखेंगी।',
  'opac.loans.renewed': 'उधार नवीनीकृत हुआ',
  'opac.loans.renewedTo': 'नवीनीकृत। नई देय तिथि {date}।',
  'opac.loans.cannotRenew': 'यह आइटम नवीनीकृत नहीं हो सकता।',
  'opac.loans.renewFrom': 'नवीनीकरण {date} से खुलेगा।',
  'opac.loans.renewalsLeft': '{count} नवीनीकरण शेष',
  'opac.loans.daysOverdue': '{count} दिन अतिदेय',
  'opac.loans.renewAllResult': '{renewed} नवीनीकृत, {failed} नवीनीकृत नहीं हो सके',
  'opac.holds.empty': 'अभी कोई होल्ड नहीं',
  'opac.holds.emptyHelp': 'किसी भी शीर्षक पर होल्ड लगाएँ, तैयार होते ही हम बताएँगे।',
  'opac.holds.showHistory': 'पिछले होल्ड दिखाएँ',
  'opac.holds.readyTitle': '{count} होल्ड लेने के लिए तैयार',
  'opac.holds.readyHelp': 'दिखाई गई अंतिम तिथि से पहले उन्हें पिकअप शेल्फ़ से ले जाएँ।',
  'opac.holds.status.PENDING': 'कतार में',
  'opac.holds.status.WAITING': 'लेने के लिए तैयार',
  'opac.holds.status.IN_TRANSIT': 'रास्ते में',
  'opac.holds.status.IN_PROCESSING': 'तैयार की जा रही',
  'opac.holds.status.FILLED': 'ले ली गई',
  'opac.holds.status.CANCELLED': 'रद्द',
  'opac.holds.status.EXPIRED': 'समाप्त',
  'opac.holds.suspended': 'रोका गया',
  'opac.holds.suspendedUntil': '{date} तक रोका गया',
  'opac.holds.suspend': 'होल्ड रोकें',
  'opac.holds.suspendUntil': 'इस तिथि तक रोकें',
  'opac.holds.suspendHint': 'खाली छोड़ें तो जब तक आप फिर शुरू न करें, रुका रहेगा।',
  'opac.holds.suspendedToast': 'होल्ड रोका गया',
  'opac.holds.resume': 'होल्ड फिर शुरू करें',
  'opac.holds.resumedToast': 'होल्ड फिर शुरू हुआ',
  'opac.holds.edit': 'होल्ड संपादित करें',
  'opac.holds.updated': 'होल्ड अद्यतन हुआ',
  'opac.holds.cancelHold': 'होल्ड रद्द करें',
  'opac.holds.cancelTitle': 'यह होल्ड रद्द करें?',
  'opac.holds.cancelBody': '{title} के लिए कतार में आपकी जगह चली जाएगी।',
  'opac.holds.cancelledToast': 'होल्ड रद्द हुआ',
  'opac.holds.pickupBy': 'इस तिथि तक लें',
  'opac.holds.pickupByDate': '{date} तक ले जाएँ',
  'opac.holds.placedOn': '{date} को लगाया',
  'opac.fines.outstanding': 'बकाया',
  'opac.fines.credits': 'उपलब्ध क्रेडिट',
  'opac.fines.balance': 'शेष',
  'opac.fines.toPay': 'चुकाने योग्य शुल्क',
  'opac.fines.pay': '{amount} चुकाएँ',
  'opac.fines.payAtDesk': 'पुस्तकालय डेस्क पर भुगतान करें',
  'opac.fines.secureNote': 'भुगतान सुरक्षित रूप से संसाधित होते हैं। पूरा होने पर रसीद मिलेगी।',
  'opac.fines.statement': 'खाता विवरण',
  'opac.fines.empty': 'कोई शुल्क नहीं',
  'opac.fines.emptyHelp': 'जुर्माने और शुल्क यहाँ दिखेंगे।',
  'opac.fines.description': 'विवरण',
  'opac.fines.amount': 'राशि',
  'opac.fines.voided': 'रद्द',
  'opac.fines.paidTitle': '{amount} का भुगतान प्राप्त हुआ',
  'opac.fines.paidBody': 'आपका खाता अद्यतन हो गया है।',
  'opac.fines.receipt': 'रसीद {number}',
  'opac.fines.sandboxNote': 'सैंडबॉक्स भुगतान: कोई वास्तविक धन नहीं गया।',
  'opac.fines.dismissed': 'भुगतान पूरा होने से पहले रद्द हो गया।',
  'opac.fines.providerFailed': 'भुगतान विंडो नहीं खुल सकी। कृपया फिर कोशिश करें।',
  'opac.history.privacy': 'पठन इतिहास की गोपनीयता',
  'opac.history.privacyHelp.DEFAULT': 'आपका इतिहास पुस्तकालय की डिफ़ॉल्ट अवधि तक रखा जाता है, फिर हटा दिया जाता है।',
  'opac.history.privacyHelp.FOREVER': 'आपका इतिहास आपके हटाने तक रखा जाता है।',
  'opac.history.privacyHelp.NEVER': 'कोई इतिहास नहीं रखा जाता। लौटाई गई किताबें तुरंत भुला दी जाती हैं।',
  'opac.history.policy.DEFAULT': 'डिफ़ॉल्ट',
  'opac.history.policy.FOREVER': 'रखें',
  'opac.history.policy.NEVER': 'कभी नहीं',
  'opac.history.privacySaved': 'गोपनीयता सेटिंग सहेजी गई',
  'opac.history.search': 'अपना इतिहास खोजें',
  'opac.history.clear': 'इतिहास साफ़ करें',
  'opac.history.clearTitle': 'अपना पठन इतिहास साफ़ करें?',
  'opac.history.clearBody': 'यह आपके इतिहास से हर लौटाया गया उधार स्थायी रूप से हटा देगा। पुष्टि के लिए DELETE टाइप करें।',
  'opac.history.cleared': 'इतिहास साफ़ हुआ',
  'opac.history.returned': '{date} को लौटाई',
  'opac.history.empty': 'अभी कोई इतिहास नहीं',
  'opac.history.emptyHelp': 'आपकी लौटाई गई किताबें यहाँ सूचीबद्ध होंगी।',
  'opac.history.off': 'इतिहास बंद है',
  'opac.history.offHelp': 'पढ़ी हुई किताबें दर्ज करने के लिए ऊपर डिफ़ॉल्ट या रखें चुनें।',
  'opac.list.edit': 'सूची संपादित करें',
  'opac.list.saved': 'सूची सहेजी गई',
  'opac.list.deleted': 'सूची हटाई गई',
  'opac.list.description': 'विवरण',
  'opac.list.visibility': 'कौन देख सकता है',
  'opac.list.visibility.PRIVATE': 'केवल मैं',
  'opac.list.visibility.SHARED': 'लिंक वाला कोई भी',
  'opac.list.visibility.PUBLIC': 'सभी',
  'opac.list.visibilityHelp.PRIVATE': 'केवल आप यह सूची देख सकते हैं।',
  'opac.list.visibilityHelp.SHARED': 'शेयर लिंक वाले लोग इसे देख सकते हैं।',
  'opac.list.visibilityHelp.PUBLIC': 'सार्वजनिक सूचियों के पृष्ठ पर दिखेगी।',
  'opac.list.shareLink': 'शेयर लिंक बनाएँ',
  'opac.list.stopSharing': 'साझा करना बंद करें',
  'opac.list.deleteTitle': 'यह सूची हटाएँ?',
  'opac.list.deleteBody': '"{name}" और उसकी प्रविष्टियाँ हटा दी जाएँगी।',
  'opac.list.emptyList': 'यह सूची खाली है',
  'opac.list.emptyListHelp': 'कोई भी किताब खोलें और सूची में जोड़ें चुनें।',
  'opac.list.moveUp': 'ऊपर ले जाएँ',
  'opac.list.moveDown': 'नीचे ले जाएँ',
  'opac.list.none': 'अभी कोई सूची नहीं',
  'opac.list.noneHelp': 'जो पढ़ना चाहते हैं उसका हिसाब रखें, या दोस्तों के साथ पठन सूची साझा करें।',
  'opac.suggest.new': 'शीर्षक सुझाएँ',
  'opac.suggest.help': 'बताएँ कि पुस्तकालय को क्या खरीदना चाहिए। हम हर सुझाव देखते हैं।',
  'opac.suggest.titleField': 'शीर्षक',
  'opac.suggest.author': 'लेखक',
  'opac.suggest.publisher': 'प्रकाशक',
  'opac.suggest.reason': 'हमें इसे क्यों खरीदना चाहिए?',
  'opac.suggest.send': 'सुझाव भेजें',
  'opac.suggest.sent': 'सुझाव भेजा गया। धन्यवाद!',
  'opac.suggest.empty': 'अभी कोई सुझाव नहीं',
  'opac.suggest.emptyHelp': 'किताब नहीं मिली? उसे खरीद के लिए सुझाएँ।',
  'opac.suggest.withdraw': 'वापस लें',
  'opac.suggest.withdrawTitle': 'यह सुझाव वापस लें?',
  'opac.suggest.withdrawn': 'सुझाव वापस लिया गया',
  'opac.ill.new': 'नया अनुरोध',
  'opac.ill.help': 'ऐसा शीर्षक उधार लाने को कहें जो इस पुस्तकालय में नहीं है।',
  'opac.ill.article': 'लेख या अध्याय का शीर्षक',
  'opac.ill.articleHint': 'केवल तब जब पूरी किताब नहीं, एक लेख की प्रति चाहिए।',
  'opac.ill.neededByField': 'कब तक चाहिए',
  'opac.ill.send': 'अनुरोध भेजें',
  'opac.ill.sent': 'अनुरोध भेजा गया',
  'opac.ill.empty': 'कोई अंतर-पुस्तकालय अनुरोध नहीं',
  'opac.ill.emptyHelp': 'हम आपके लिए अन्य पुस्तकालयों से किताबें और लेख मँगा सकते हैं।',
  'opac.ill.requested': '{date} को अनुरोध किया',
  'opac.ill.neededBy': '{date} तक चाहिए',
  'opac.ill.fee': 'शुल्क {amount}',
  'opac.ill.cancel': 'अनुरोध रद्द करें',
  'opac.ill.cancelTitle': 'यह अनुरोध रद्द करें?',
  'opac.ill.cancelled': 'अनुरोध रद्द हुआ',
  'opac.event.waitlistPos': 'प्रतीक्षा सूची #{position}',
  'opac.rooms.bookings': 'कक्ष बुकिंग',
  'opac.rooms.cancel': 'बुकिंग रद्द करें',
  'opac.rooms.cancelTitle': 'यह बुकिंग रद्द करें?',
  'opac.rooms.cancelled': 'बुकिंग रद्द हुई',
  'opac.me.saved': 'प्रोफ़ाइल सहेजी गई',
  'opac.me.member': '{date} से सदस्य',
  'opac.me.changePhoto': 'फ़ोटो बदलें',
  'opac.me.photoSaved': 'फ़ोटो अद्यतन हुई',
  'opac.me.nameLocked': 'आपका नाम पुस्तकालय द्वारा प्रबंधित है। बदलने के लिए डेस्क पर पूछें।',
  'opac.me.secondaryEmail': 'दूसरा ईमेल',
  'opac.me.address2': 'पता पंक्ति 2',
  'opac.me.language': 'भाषा',
  'opac.me.changePassword': 'पासवर्ड बदलें',
  'opac.me.currentPassword': 'वर्तमान पासवर्ड',
  'opac.me.newPassword': 'नया पासवर्ड',
  'opac.me.passwordChanged': 'पासवर्ड बदल गया',
  'opac.me.markAllRead': 'सभी पढ़ा हुआ करें',
  'opac.me.markRead': 'पढ़ा हुआ करें',
  'opac.me.allRead': 'सभी सूचनाएँ पढ़ी हुई चिह्नित हुईं',
  'opac.me.noNotifications': 'कोई सूचना नहीं',
  'opac.me.noNotificationsHelp': 'तैयार होल्ड, देय तिथियाँ और पुस्तकालय समाचार यहाँ दिखेंगे।',
  'opac.me.appearance': 'भाषा और थीम',
  'opac.me.theme': 'थीम',
  'opac.me.themeLight': 'हल्की',
  'opac.me.themeDark': 'गहरी',
  'opac.me.themeSystem': 'सिस्टम',
  'opac.me.messaging': 'हम आपसे कैसे संपर्क करें',
  'opac.me.messagingHelp': 'चुनें कि हर प्रकार की सूचना कहाँ भेजी जाए।',
  'opac.me.noticeType': 'सूचना',
  'opac.me.medium.EMAIL': 'ईमेल',
  'opac.me.medium.SMS': 'SMS',
  'opac.me.medium.PUSH': 'ऐप',
  'opac.me.medium.WHATSAPP': 'व्हाट्सऐप',
  'opac.me.digest': 'एक दैनिक संदेश में मिलाएँ',
  'opac.me.prefsSaved': 'प्राथमिकताएँ सहेजी गईं',
};
